import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table_content_container seven_column" }
const _hoisted_2 = { class: "body_content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "column text_capitalize" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "column text-center" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_head_column = _resolveComponent("head-column")!
  const _component_table_filter = _resolveComponent("table-filter")!
  const _component_show_experience_period_selected = _resolveComponent("show-experience-period-selected")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_table_filter, {
      pagedRequest: _ctx.requestFilter,
      "onUpdate:pagedRequest": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestFilter) = $event)),
      totalItems: _ctx.totalItems,
      onChangeSort: _ctx.changeSort
    }, {
      default: _withCtx(() => [
        _createVNode(_component_head_column, { param: "createdOn" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_CreatedOn",
              text: "CreatedOn"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_head_column, { param: "creator.text" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Creator",
              text: "Creator"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_head_column, {
          param: 'category.title.Values.' + _ctx.lang,
          sortable: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Category",
              text: "Category"
            })
          ]),
          _: 1
        }, 8, ["param"]),
        _createVNode(_component_head_column, { param: "periodTitle" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Period",
              text: "Period"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_head_column, { param: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Title",
              text: "Title"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_head_column, null, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Stato",
              text: "Stato"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_head_column, { param: "isActive" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "backoffice_Attivo",
              text: "Attivo"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["pagedRequest", "totalItems", "onChangeSort"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "body_list",
          key: item.identifier,
          onClick: ($event: any) => (_ctx.rowClicked(item.experienceIdentifier))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "DD/MM/yyyy HH:mm")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(item.creator.text), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (item.category)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$localizationService.getTextFromLocalizedValue(item.category.title)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "---"))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_show_experience_period_selected, {
              periodSelected: item.period.title
            }, null, 8, ["periodSelected"]),
            (item.approvedData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.period.period.start, "DD/MM/yyyy HH:mm")), 1),
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.period.period.end, "DD/MM/yyyy HH:mm")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getStatus(item.approvedData)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", null, _toDisplayString(item.isActive), 1)
          ])
        ], 8, _hoisted_3))
      }), 128)),
      (_ctx.totalItems == 0)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            class: "no_table_content",
            localizedKey: "backoffice_NessunRisultato",
            text: "Nessun risultato"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}